// src/store/slices/tagsSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';



const BaseUrl = process.env.REACT_APP_BASH_URL;
const API_URL = `${BaseUrl}/admin/blogs/tags`;

// Async Thunks
export const fetchTags = createAsyncThunk('tags/fetchTags', async () => {
  const token = localStorage.getItem("admin-auth-token");
    const response = await axios.get(`${API_URL}`, { headers: { Authorization: `Bearer ${token}` } });
 return response.data;
});

export const deleteTags = createAsyncThunk('tags/deleteTags', async (ids) => {
  const token = localStorage.getItem("admin-auth-token");
    const response = await axios.post(`${API_URL}/delete`, { ids }, { headers: { Authorization: `Bearer ${token}` } });
  return ids;
});

export const createTag = createAsyncThunk('tags/create', async (data) => {
  const token = localStorage.getItem("admin-auth-token");
    const response = await axios.post(`${API_URL}`, data, { headers: { Authorization: `Bearer ${token}` } });
  return response.data;
});


export const editTags = createAsyncThunk('tags/editTags', async ({ ids, name }) => {
  const token = localStorage.getItem("admin-auth-token");
    const response = await axios.post(`${API_URL}/edit`,{ ids, name }, { headers: { Authorization: `Bearer ${token}` } });
  return { ids, updatedName: name };
});

// Slice
const tagsSlice = createSlice({
  name: 'tags',
  initialState: {
    tags: [],
    loading: false,
    error: null,
  },
  reducers: {
    toggleTagSelection: (state, action) => {
      const tag = state.tags.find(t => t.id === action.payload);
      if (tag) tag.selected = !tag.selected;
    },
    toggleAllSelection: (state, action) => {
      state.tags.forEach(tag => tag.selected = action.payload);
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchTags.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchTags.fulfilled, (state, action) => {
        state.loading = false;
        state.tags = action.payload.map(tag => ({ ...tag, selected: false }));
      })
      .addCase(createTag.fulfilled, (state, action) => {
        state.loading = false;
        console.log(action.payload)
        state.tags.push(action.payload.tag);
      })
      .addCase(fetchTags.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(deleteTags.fulfilled, (state, action) => {
        state.tags = state.tags.filter(tag => !action.payload.includes(tag._id));
      })
      .addCase(editTags.fulfilled, (state, action) => {
        state.tags = state.tags.map(tag =>
          action.payload.ids.includes(tag.id)
            ? { ...tag, name: action.payload.updatedName }
            : tag
        );
      });
  },
});

export const { toggleTagSelection, toggleAllSelection } = tagsSlice.actions;
export default tagsSlice.reducer;
